import React from 'react'

import { ProductIds } from 'core'

import { useLoginUserV2 } from '../common/hooks'
import GroupHraEEDashboard from './groupHra'
import IchraEEDashboard from './ichra'
import PerksEEDashboard from './perks'
import QsehraEEDashboard from './qsehra'

const EmployeeDashboard: React.FC = () => {
  const { user } = useLoginUserV2()

  const eeDashboard = new Map<number, any>()
  eeDashboard.set(ProductIds.GroupHraId, <GroupHraEEDashboard />)
  eeDashboard.set(ProductIds.Perks, <PerksEEDashboard />)
  eeDashboard.set(ProductIds.QsehraId, <QsehraEEDashboard />)
  eeDashboard.set(ProductIds.IchraId, <IchraEEDashboard />)

  return eeDashboard.get(user.productId)
}

export default EmployeeDashboard
